import React from 'react';
import cs from 'classnames';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { Button } from '../../components/Button';
import IntlMessages from '../../util/IntlMessages';

class NotFoundPage extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Box className="app-wrapper" sx={{ width: '100%' }}>
        <div
          className={cs([
            'app-wrapper',
            'page-error-container',
            'animated',
            'slideInUpTiny',
            'animation-duration-3',
          ])}
        >
          <div className="page-error-content">
            <Box className="error-code animated zoomInDown" sx={{ mb: 3 }}>
              404
            </Box>
            <Box
              component="h2"
              className="fw-regular title bounceIn animation-delay-10 animated"
              sx={{ textAlign: 'center' }}
            >
              <span>
                <IntlMessages id="extraPages.404Msg" />
              </span>
            </Box>
            <Box className="zoomIn animation-delay-20 animated" sx={{ textAlign: 'center' }}>
              <Button
                labelId="extraPages.goHome"
                component={Link}
                to="/"
                variant="contained"
                color="primary"
                size="small"
              />
            </Box>
          </div>
        </div>
      </Box>
    );
  }
}

export default NotFoundPage;
